<template>
  <div class="bg- flex-1 flex flex-col relative">
    <div class="h-16">
      <div
        class="absolute top-0 flex flex-no-wrap"
        style="
          min-height: 50px;
          left: 50%;
          margin-left: 20px;
          width: calc(100% - (192px + 20px) - 60px);
          gap: 15px;
          transform: translateX(-50%);
        "
      >
        <div
          class="absolute bg-primary text-white p-4 py-2 rounded-b-lg"
          style="
            left: 50%;
            top: 100%;
            position: absolute;
            transition: 0.2s;
            z-index: 1;
          "
          :style="{
            transform: `translate(-50%, ${isLoadingMain ? 0 : -100}%)`,
          }"
        >
          Fetching data
        </div>
        <div
          class="relative flex flex-no-wrap h-full w-full overflow-x-auto bg-white shadow-md p-3 rounded-b-lg items-center justify-between gap-6"
          style="z-index: 99999; overflow: clip"
        >
          <div class="flex flex-no-wrap justify-start items-center gap-6">
            <assets-select
              @selected="(v) => (selectedUnits = v)"
              style="max-width: 500px"
              :class="[isLoadingMain || isLoading ? 'pointer-events-none' : '']"
              :disable="isLoadingMain || isLoading"
            />
            <export-button :excel-data="excelData" @modal="exportPdf" />
          </div>
          <div
            class="flex flex-1 flex-no-wrap justify-end items-center"
            style="gap: 25px"
          >
            <filter-btn
              :stat="stat"
              @filter-type="filtering"
              :filter="filterType"
              style="white-space: nowrap"
            />
            <div
              class="relative mr-4"
              ref="target"
              style="height: 30px; width: 200px"
            >
              <input
                v-model="search"
                type="text"
                class="fit rounded-full pl-4 pr-10"
                style="border: solid 1px black"
              />
              <q-icon
                :name="search.trim() == '' ? 'search' : 'close'"
                class="absolute right-0 cursor-pointer"
                :class="{ 'mr-2': search.trim() != '' }"
                :size="search.trim() == '' ? '26px' : '20px'"
                style="
                  top: 50%;
                  transform: translate(-5px, -50%);
                  transition: 0.2s;
                "
                @click="search.trim() == '' ? void 0 : (search = '')"
              />
              <!-- <q-tooltip content-class="bg-primary"> Search Table </q-tooltip> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1 bg- overflow-hidden flex">
      <!-- <pre>{{ visibleColumns }}</pre> -->
      <table-view
        class="flex-1"
        :data="filteredData"
        @chart="action"
        :chart="chart"
        :loading="loading"
        :visibleColumns="visibleColumns"
        @map="openMap"
      />
    </div>
    <!-- modal -->
    <Transition name="scale">
      <modal-view
        v-if="modalOpen"
        @close-modal="modalOpen = false"
        :data="chartData"
      />
    </Transition>
    <!-- modal -->
    <Transition name="scale">
      <modal-comp
        v-if="mapModal"
        @close="mapModal = false"
        :data="modalData"
        :component="modalComponent"
      />
    </Transition>
  </div>
</template>

<script setup>
// import { onClickOutside } from '@vueuse/core';
import { onMounted, onUnmounted, ref, watch, computed } from 'vue';
import { axios } from '@/main.js';
import moment from 'moment';

import AssetsSelect from '../map-view/AssetsSelect.vue';
import FilterBtn from '../map-view/FilterBtn.vue';
import ModalView from '../map-view/ModalView.vue';
import TableView from './TableView.vue';
import ExportButton from './ExportButton.vue';
import ModalComp from './ModalComp.vue';

// const
const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const geoPOIData = JSON.parse(localStorage.getItem('geoPOIData'));

// data
const data = ref([]);
const filteredData = computed(() => {
  let arr = [];
  let filter = filterType.value[0];
  let selected = data.value.filter((e) =>
    selectedUnits.value.includes(e.assetId),
  );
  stat.value = getStat(selected);
  if (filter == 'All') {
    arr = selected;
  } else {
    arr = selected.filter((e) => {
      return statusList[e.status] == filter ? e : void 0;
    });
  }
  if (search.value.trim() != '') {
    arr = searchAssetName(arr, search.value);
  }
  return arr;
});

const columns = [
  { name: 'assetName', label: 'Asset', style: 'width:15%' },
  { name: 'lastUpdated', label: 'Time', style: 'width:5%' },
  { name: 'Ignition', style: 'width:5%' },
  { name: 'idlingStatus', label: 'Idling', style: 'width:5%' },
  { name: 'Speed', style: 'width:5%' },
  { name: 'mileage', label: 'Odometer', style: 'width:5%' },
  { name: 'Fuel', align: 'center' },
  { name: 'Temp' },
  { name: 'gps', label: 'GPS' },
  { name: 'input', label: 'Input' },
  { name: 'output', label: 'Output' },
  { name: 'address', label: 'Location' },
  { name: 'Status', align: 'center' },
];
const visibleColumns = computed(() => {
  const propsCheck = ['idlingStatus', 'fuel', 'temp', 'input', 'output'];
  const valueCheck = ['-', '-', '-', '-', '-'];

  const visible = columns.map((e) =>
    !e.label ? e.name.toLowerCase() : e.name,
  );
  const empty = propsCheck.filter((prop, i) =>
    filteredData.value.every((obj) => obj[prop] === valueCheck[i]),
  );

  const filteredColumns = columns.filter(
    (e) =>
      visible.includes(!e.label ? e.name.toLowerCase() : e.name) &&
      !empty.includes(!e.label ? e.name.toLowerCase() : e.name),
  );
  const result = filteredColumns.map((e) => e.name);
  console.log(result);

  return result;
});
const stat = ref([]);
const getStat = (arr) => {
  const stat = [0, 0, 0, 0];
  const list = {
    Moving: 0,
    Idling: 1,
    Parked: 2,
    Inactive: 3,
  };
  arr.forEach((e) => {
    stat[list[e.status]] += 1;
  });
  return stat;
};
onMounted(async () => {
  await getData();
});
async function getData() {
  if (!timer.value) {
    startTimer();
  }
  try {
    let response = await axios.post(`multiUnitDetailsv2/${userInfo.uid}`, {
      selectedUnits: selectedUnits.value,
      geoPOIData: geoPOIData,
    });
    if (response.status == 200 && response.data.success) {
      data.value = response.data.unitDetails;
      data.value.forEach((e, i) => {
        data.value[i] = {
          ...e,
          ...{ fuelLoading: false, tempLoading: false },
        };
      });
    }
  } catch (error) {
    console.log(error);
  }
}

// exports
const exportPdf = (v) => {
  modalData.value = v;
  modalComponent.value = 'ReportsPdfExport';
  mapModal.value = true;
};
const excelData = computed(() => {
  let v = [
    {
      fileName: '',
      header: [],
      data: [],
      fields: [],
      labels: [],
      colsWidth: [],
      filter: filterType.value,
    },
  ];
  let colsWidth = [100, 100, 50, 40, 40, 50, 60, 40, 40, 50, 120, 50];
  if (data.value.length > 0) {
    let obj = v[0];
    let time = moment().format('D/M/YYYY | HH:mm:ss');
    obj.fileName = `Vehicle List ${filterType.value} ${time}`;
    obj.header = [
      [`Report Type : Vehicle List`],
      [`Filter : ${filterType.value}`],
      [`Time            :  ${time}`],
      [],
    ];
    obj.data = filteredData.value;
    visibleColumns.value.forEach((e) => {
      columns.forEach((col, i) => {
        if (e == col.name) {
          if (!col.label) {
            obj.labels.push(col.name);
            obj.fields.push(col.name.toLowerCase());
          } else {
            obj.labels.push(col.label);
            obj.fields.push(col.name);
          }
          obj.colsWidth.push(colsWidth[i]);
        }
      });
    });
  }
  return v[0];
});

// map
const modalComponent = ref(null);
const mapModal = ref(false);
const modalData = ref(null);
function openMap(row) {
  modalData.value = `${row.lat},${row.lng}`;
  modalComponent.value = 'GoogleMapEmbed';
  mapModal.value = true;
}

// chart
const chartData = ref(null);
const dataSource = ref({});
async function action([label, props]) {
  if (loading.value) return;
  if (label == 'fuel' || label == 'temp') {
    chart.value = label;
    // loading.value = propsIndex;
    // fetchFuelData.value = true;
    const { data, dataSchema } = await getChart(
      props.assetId,
      props.assetName,
      props.unitId,
      label == 'fuel' ? 'refuelChart' : 'temperatureChart',
    );
    if (label == 'temp') {
      dataSource.value = tempChartOptions(props.assetName);
    }
    chartData.value = null;
    loading.value = null;
    setTimeout(() => {
      chartData.value = {
        data,
        dataSchema,
        dataSource: dataSource.value,
      };
      modalOpen.value = true;
    }, 10);
  }
}
async function getChart(assetId, assetName, unitId, url) {
  let response = await axios.post(
    `${url}/${assetId}/${userInfo.uid}/${unitId}`,
    {
      timeRange: 'daily',
      geoPOIData: geoPOIData.value,
    },
  );
  if (response.status == 200 && response.data.success) {
    const data = response.data.series;
    dataSource.value = fuelChartOptionsV1(assetName);
    dataSource.value.datamarker = response.data.datamarker;

    const dataSchema = response.data.dataSchema;
    if (response.data.type == 2) {
      dataSource.value.chart.palettecolors = 'FF0000,FFD700,0000FF,008000';
      dataSource.value.yaxis = fuelChartOptionsV2(assetName);
    }
    return { data, dataSchema };
  } else if (response.data.error) {
    console.log(response.data.error);
    return;
  } else {
    console.log(response);
    return;
  }
}
function tempChartOptions(assetName) {
  return {
    data: null,
    navigator: {
      enabled: 0,
    },
    extensions: {
      customRangeSelector: {
        enabled: 0,
      },
    },
    chart: {
      animation: 0,
      palettecolors: '800080,000000,0000FF,008000',
      multicanvas: false,
      exportEnabled: 1,
      exportFileName: `Temperature Chart -${assetName}`,
    },
    caption: {
      text: `Temperature Chart -${assetName}`,
    },
    datamarker: null,
    yaxis: [
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_1',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_2',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_3',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Temperature_4',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        min: -30,
        min: 100,
        plot: [
          {
            value: 'Preferred_Temperature',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' °C',
        },
      },
      {
        plot: [
          {
            value: 'Odometer',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: '',
        },
      },
      {
        min: 0,
        max: 200,
        plot: [
          {
            value: 'Speed',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' kph',
        },
      },
    ],
  };
}
function fuelChartOptionsV1(assetName) {
  return {
    data: null,
    navigator: {
      enabled: 0,
    },
    extensions: {
      customRangeSelector: {
        enabled: 0,
      },
    },
    chart: {
      animation: 0,
      palettecolors: 'FF0000,0000FF,008000',
      multicanvas: false,
      exportEnabled: 1,
      exportFileName: 'Fuel Chart',
    },
    caption: {
      text: `Fuel Chart - ${assetName}`,
    },
    datamarker: null,
    yaxis: [
      {
        min: 0,
        plot: [
          {
            value: 'Fuel',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' litres',
        },
      },
      {
        plot: [
          {
            value: 'Odometer',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: '',
        },
      },
      {
        min: 0,
        max: 200,
        plot: [
          {
            value: 'Speed',
            connectnulldata: true,
            type: 'line',
          },
        ],
        format: {
          suffix: ' kph',
        },
      },
    ],
  };
}
function fuelChartOptionsV2() {
  return [
    {
      min: 0,
      plot: [
        {
          value: 'Fuel',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: ' litres',
      },
    },
    {
      min: 0,
      plot: [
        {
          value: 'Fuel2',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: ' litres',
      },
    },
    {
      plot: [
        {
          value: 'Odometer',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: '',
      },
    },
    {
      min: 0,
      max: 200,
      plot: [
        {
          value: 'Speed',
          connectnulldata: true,
          type: 'line',
        },
      ],
      format: {
        suffix: ' kph',
      },
    },
  ];
}

// interactive
const allUnits = JSON.parse(localStorage.getItem('allUnits'));
const selectedUnits = ref(allUnits);
watch(selectedUnits, () => {
  if (selectedUnits.value.length == 0) {
    selectedUnits.value = allUnits;
  }
});

const modalOpen = ref(false);
const loading = ref(null);
const chart = ref(null);
const isLoading = ref(null);
const isLoadingMain = ref(null);
const filterType = ref(['All']);

const statusList = {
  Moving: 'Move',
  Idling: 'Idle',
  Parked: 'Park',
  Inactive: 'Inactive',
};
function filtering(filter, v2) {
  if (JSON.stringify(filter) == JSON.stringify(filterType.value)) return;
  if (!v2) {
    filterType.value = filter;
  }
}

// search
const search = ref('');
watch(search, (v) => {
  if (v.trim() != '') {
    // do search
  }
});
function searchAssetName(objects, searchQuery) {
  // Convert the search query to lowercase for a case-insensitive search
  const lowercasedQuery = searchQuery.toLowerCase();

  // Filter the array of objects based on the assetName property
  const results = objects.filter((obj) => {
    // Convert assetName to lowercase for case-insensitive comparison
    const lowercasedAssetName = obj.assetName.toLowerCase();

    // Check if the lowercased assetName contains the lowercased search query
    return lowercasedAssetName.includes(lowercasedQuery);
  });

  return results;
}

// lap

const lap = ref(0);
const time = ref(10);
const seconds = ref(60);
const timer = ref(null);

watch(lap, async () => {
  await getData();
});

function startTimer() {
  time.value = seconds.value;
  timer.value = setInterval(() => {
    if (time.value > 0) {
      time.value--;
    } else {
      resetTimer();
    }
  }, 1000);
}
function resetTimer() {
  clearInterval(timer.value);
  if (selectedUnits.value.length != 0) {
    lap.value++;
    startTimer();
  } else {
    time.value = seconds.value;
  }
}

onUnmounted(() => {
  clearInterval(timer.value);
});
</script>

<style>
.header-shadow {
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.123),
    0 2px 25px rgba(0, 0, 0, 0.027);
  & > * {
    font-weight: 900 !important;
  }
}
</style>
